import Tooltip from './modules/Tooltip'

document.addEventListener("alpine:init", () => {
    Alpine.directive('tooltip', Tooltip).before('bind')
});